import { Component } from '@angular/core';

/**
 * Initialize the base user management component.
 */
@Component({
  selector: 'app-user-management',
  templateUrl: 'user-management.component.html',
  styles: ['']
})

export class UserManagementComponent {
  constructor() {}
}
